(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/prescript.js'); 
var svs = svs || {};
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity = svs.terms_integrity || {};

  svs.terms_integrity.app = new Backbone.Marionette.Application({
    region: '#terms-integrity',

    onStart: function() {
      svs.terms_integrity_logger = new svs.core.log.Logger('module:terms-integrity');
      svs.terms_integrity.router = new svs.terms_integrity.Router();
      Backbone.history.start({ pushState: true, root: svs.core.data.baseUrl });
    }
  });

  svs.terms_integrity.data = svs.terms_integrity.data || {};
  svs.terms_integrity.views = svs.terms_integrity.views || {};
  svs.terms_integrity.models = svs.terms_integrity.models || {};
  svs.terms_integrity.router = svs.terms_integrity.router || {};
})(Backbone, svs);

 })(window);